module.exports = __webpack_public_path__ + "img/01_content_01.539fad5c.png";